/*

dataflow
build from the Flux pattern
This is the utility to enable the fluxpattern.

usage:
register, dispatch

Any module registers functions that then are invoked with any payload as argument.

var someFunctionWhichFiltersBehaviourFromPayloadType = function (payload) {
    if (payload.type === selected_type) {
        dosomething(payload.data);
    }
}

require('../../common/lib/dataflow').register(someFunctionWhichFiltersBehaviourFromPayloadType);
require('../../common/lib/dataflow').dispatch({
    'type': 'action_type',
    'data_1': 'some_data',
    'data_2': 'some other data'
}
});


*/
import dispatcher from './utils/dispatcher.js';

export default {
	register(cb) {
		dispatcher.register(cb);
	},
	unregister(cb) {
		dispatcher.unregister(cb);
	},
	dispatch(payload) {
		dispatcher.dispatch(payload);
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/common/lib/dataflow.js